import Header from "./shared/header";
import Footer from "./shared/footer";
import MobileLayout from "./shared/mobile_layout";
import { useState, useEffect } from "react";

import Contact from "./shared/contact";
import DesktopLayout from "./shared/desktop_layout";
import Process from "./shared/home/process";
import Enterprise from "./shared/home/enterprise";
import WeDidntBuild from "./shared/about/we_didnt_build";
import ModernConsulting from "./shared/about/modern_consulting";
import BuiltOnAWS from "./shared/about/built_on_aws";
import HumanDigitalTeams from "./shared/about/human_digital_teams";
import ClientBenefits from "./shared/about/client_benefits";
import WhatSetsUsApart from "./shared/about/what_sets_us_apart";
import ConsultingPyramid from "./shared/about/consulting_pyramid";

function Story() {
  const enterpriseData = [
    {
      title: "Deploy Generative AI applications that provide immediate value",
      description:
        "OneByZero has significant experience in exploiting generative Al for enterprise search, natural language queries, question-answering, summarization, personalization, content generation and chatbot use-cases.",
      img: "images/home/enterprise/enterprise-1.webp",
      img_mob: "images/home/enterprise/enterprise-1-mob.webp",
    },
    {
      title: "Enhance customer experience across all channels",
      description:
        "OneByZero has a variety of assets and experience around personalization, next-best action and omni-channel messaging use-cases that can drive customer acquisition, engagement and retention.",
      img: "images/home/enterprise/enterprise-2.webp",
      img_mob: "images/home/enterprise/enterprise-2-mob.webp",
    },
    {
      title: "Build a modern data foundation to power AI/ML use-cases",
      description:
        "OneByZero will help you deploy a modern data stack, with specific focus on data quality, governance, security, performance and flexibility, that can be the foundation for BI, ML and Al use-cases across the enterprise.",
      img: "images/home/enterprise/enterprise-3.webp",
      img_mob: "images/home/enterprise/enterprise-3-mob.webp",
    },
  ];
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const Layout = ({ children, backgroundColor }) => {
    return screenSize <= 768 ? (
      <MobileLayout backgroundColor={backgroundColor}>{children}</MobileLayout>
    ) : (
      <DesktopLayout backgroundColor={backgroundColor}>
        {children}
      </DesktopLayout>
    );
  };

  return (
    <div>
      <Layout>
        <Header color="rgba(11, 21, 76, 1)" />
      </Layout>
      <div className="h-[24px] bg-white" />
      <Layout backgroundColor="black">
        <Layout>
          <WeDidntBuild />
        </Layout>
        <ModernConsulting />
      </Layout>
      <Layout>
        <BuiltOnAWS />
      </Layout>
      <Layout backgroundColor="black">
        <HumanDigitalTeams />
      </Layout>
      <Layout>
        <ClientBenefits />
      </Layout>
      <Layout backgroundColor="black">
        <WhatSetsUsApart />
      </Layout>
      <Layout backgroundColor="black">
        <ConsultingPyramid />
      </Layout>
      <Layout>
        <Footer />
      </Layout>
    </div>
  );
}

export default Story;
